export const sortData = (data, sortBy, sortDir) => {
  if (!sortDir) return data

  const compare = (a, b) => {
    if (a[sortBy] < b[sortBy]) return sortDir === 'asc' ? -1 : 1
    if (a[sortBy] > b[sortBy]) return sortDir === 'asc' ? 1 : -1
    return 0
  }

  return sortBy ? data.slice().sort(compare) : data
}

export const isNumber = number =>
  (typeof number === "string")
    ? false
    : !isNaN(number) && !isNaN(parseFloat(number))

const grandTotal = data =>
  Object
    .values(data)
    .reduce((a, b) => (isNumber(b) ? a + b : a), 0)

const totalPerSource = (data, isGrandTotal = false) =>
  data.reduce((a, b) => {
    for (const k in b) {
      if (k === 'port')
        a[k] = isGrandTotal ? 'Grand Total' : `${ b[k] } Total`
      else if (k === 'mine')
        a[k] = '-'
      else if (k === 'source')
        a[k] = '-'
      else if (b.hasOwnProperty(k))
        a[k] = (a[k] || 0) + isNumber(b[k]) ? b[k] : 0
    }
    return a
  },{})

export const transformData = data => {
  const arr = data.reduce((accArr, currArr) => (
    [
      ...accArr,
      {
        ...currArr,
        grand_total: grandTotal(currArr)
      }
    ]
  ), [])

  let start = 0;
  return arr
    .reduce((acc, _, end) => {
      if (arr.length === end + 1 || arr[end].port !== arr[end + 1].port) {
        const slice = arr.slice(start, end + 1)
        start = end + 1
        if (arr.length === end + 1) {
          return [...acc, ...slice, totalPerSource(slice), totalPerSource(arr, true)]
        } else {
          return [...acc, ...slice, totalPerSource(slice)]
        }
      } else {
        return acc
      }
    }, [])
}
